//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { environment } from "@environments/environment";
import { Observable, of as _observableOf, throwError as _observableThrow } from 'rxjs';
import { catchError as _observableCatch, mergeMap as _observableMergeMap } from 'rxjs/operators';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export class Foo {
  protected getBaseUrl(deaultUrl: string): string {
    return environment.remoteServiceBaseUrl;
  }
}

@Injectable({
    providedIn: 'root'
})
export class SessionServiceProxy extends Foo {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getSupportedIANATimezones(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetSupportedIANATimezones";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupportedIANATimezones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupportedIANATimezones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetSupportedIANATimezones(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setAvailablity(body: CalendarAvailability | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Session/SetAvailablity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAvailablity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAvailablity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAvailablity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param timezone (optional) 
     * @return OK
     */
    setTimezone(timezone: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Session/SetTimezone?";
        if (timezone === null)
            throw new Error("The parameter 'timezone' cannot be null.");
        else if (timezone !== undefined)
            url_ += "timezone=" + encodeURIComponent("" + timezone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetTimezone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetTimezone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetTimezone(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setProfilepic(body: PictureInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Session/SetProfilepic";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetProfilepic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetProfilepic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetProfilepic(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Session/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getSelf(): Observable<GetSelfOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetSelf";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSelf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSelf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSelfOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSelfOutput>;
        }));
    }

    protected processGetSelf(response: HttpResponseBase): Observable<GetSelfOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSelfOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getConnectedAccounts(): Observable<GetConnectedAccountsAsyncOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetConnectedAccounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConnectedAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConnectedAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetConnectedAccountsAsyncOutput[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetConnectedAccountsAsyncOutput[]>;
        }));
    }

    protected processGetConnectedAccounts(response: HttpResponseBase): Observable<GetConnectedAccountsAsyncOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetConnectedAccountsAsyncOutput.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param loginProvider (optional) 
     * @param providerKey (optional) 
     * @return OK
     */
    deleteConnectedAccount(loginProvider: string | undefined, providerKey: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Session/DeleteConnectedAccount?";
        if (loginProvider === null)
            throw new Error("The parameter 'loginProvider' cannot be null.");
        else if (loginProvider !== undefined)
            url_ += "LoginProvider=" + encodeURIComponent("" + loginProvider) + "&";
        if (providerKey === null)
            throw new Error("The parameter 'providerKey' cannot be null.");
        else if (providerKey !== undefined)
            url_ += "ProviderKey=" + encodeURIComponent("" + providerKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConnectedAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConnectedAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteConnectedAccount(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    recheckConnectedAccounts(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Session/RecheckConnectedAccounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecheckConnectedAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecheckConnectedAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRecheckConnectedAccounts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    deleteSelf(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Session/DeleteSelf";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSelf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSelf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSelf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateSelf(body: UpdateSelfInput | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/Session/UpdateSelf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSelf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSelf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUpdateSelf(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveBlockingOutputCalendarPreferences(body: SaveBlockingOutputCalendarPreferencesInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Session/SaveBlockingOutputCalendarPreferences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveBlockingOutputCalendarPreferences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveBlockingOutputCalendarPreferences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveBlockingOutputCalendarPreferences(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setBlockingExternalCalendars(body: string[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Session/SetBlockingExternalCalendars";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetBlockingExternalCalendars(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetBlockingExternalCalendars(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetBlockingExternalCalendars(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    setOutputingExternalCalendar(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Session/SetOutputingExternalCalendar?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetOutputingExternalCalendar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetOutputingExternalCalendar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetOutputingExternalCalendar(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateBlockingExternalCalendar(body: UpdateExternalCalendarBlockSaveDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Session/UpdateBlockingExternalCalendar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBlockingExternalCalendar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBlockingExternalCalendar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBlockingExternalCalendar(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateOutputExternalCalendar(body: UpdateExternalCalendarBlockSaveDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Session/UpdateOutputExternalCalendar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOutputExternalCalendar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOutputExternalCalendar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOutputExternalCalendar(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    refreshExternalCalendarsForUser(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Session/RefreshExternalCalendarsForUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshExternalCalendarsForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshExternalCalendarsForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRefreshExternalCalendarsForUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllExternalCalendars(): Observable<ExternalCalendarProviderWithCalendars[]> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetAllExternalCalendars";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllExternalCalendars(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExternalCalendars(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalCalendarProviderWithCalendars[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalCalendarProviderWithCalendars[]>;
        }));
    }

    protected processGetAllExternalCalendars(response: HttpResponseBase): Observable<ExternalCalendarProviderWithCalendars[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalCalendarProviderWithCalendars.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addExternalConnection(body: AddExternalConnectionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Session/AddExternalConnection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddExternalConnection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddExternalConnection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddExternalConnection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getNextFreeCreditsUpdateDate(): Observable<Date> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetNextFreeCreditsUpdateDate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextFreeCreditsUpdateDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextFreeCreditsUpdateDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Date>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Date>;
        }));
    }

    protected processGetNextFreeCreditsUpdateDate(response: HttpResponseBase): Observable<Date> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? new Date(resultData200.toString()) : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    reflectSubscription(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Session/ReflectSubscription";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReflectSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReflectSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReflectSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCustomerPortalURL(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCustomerPortalURL";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerPortalURL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerPortalURL(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetCustomerPortalURL(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param plantype (optional) 
     * @param currency (optional) 
     * @param gAClientID (optional) 
     * @return OK
     */
    getCheckoutURL(plantype: string | undefined, currency: string | undefined, gAClientID: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCheckoutURL?";
        if (plantype === null)
            throw new Error("The parameter 'plantype' cannot be null.");
        else if (plantype !== undefined)
            url_ += "plantype=" + encodeURIComponent("" + plantype) + "&";
        if (currency === null)
            throw new Error("The parameter 'currency' cannot be null.");
        else if (currency !== undefined)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        if (gAClientID === null)
            throw new Error("The parameter 'gAClientID' cannot be null.");
        else if (gAClientID !== undefined)
            url_ += "GAClientID=" + encodeURIComponent("" + gAClientID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCheckoutURL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCheckoutURL(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetCheckoutURL(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllCultures(): Observable<CultureInfo[]> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetAllCultures";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCultures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCultures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CultureInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CultureInfo[]>;
        }));
    }

    protected processGetAllCultures(response: HttpResponseBase): Observable<CultureInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CultureInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    completeOnboarding(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Session/CompleteOnboarding";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteOnboarding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteOnboarding(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompleteOnboarding(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getSessionUserLanguage(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetSessionUserLanguage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSessionUserLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSessionUserLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetSessionUserLanguage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AddExternalConnectionInput implements IAddExternalConnectionInput {
    provider!: string | undefined;
    authenticationTokens!: AuthenticationToken[] | undefined;
    providerKey!: string | undefined;

    constructor(data?: IAddExternalConnectionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.authenticationTokens) {
                this.authenticationTokens = [];
                for (let i = 0; i < data.authenticationTokens.length; i++) {
                    let item = data.authenticationTokens[i];
                    this.authenticationTokens[i] = item && !(<any>item).toJSON ? new AuthenticationToken(item) : <AuthenticationToken>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provider = _data["provider"];
            if (Array.isArray(_data["authenticationTokens"])) {
                this.authenticationTokens = [] as any;
                for (let item of _data["authenticationTokens"])
                    this.authenticationTokens!.push(AuthenticationToken.fromJS(item));
            }
            this.providerKey = _data["providerKey"];
        }
    }

    static fromJS(data: any): AddExternalConnectionInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddExternalConnectionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider;
        if (Array.isArray(this.authenticationTokens)) {
            data["authenticationTokens"] = [];
            for (let item of this.authenticationTokens)
                data["authenticationTokens"].push(item.toJSON());
        }
        data["providerKey"] = this.providerKey;
        return data;
    }
}

export interface IAddExternalConnectionInput {
    provider: string | undefined;
    authenticationTokens: IAuthenticationToken[] | undefined;
    providerKey: string | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version!: string | undefined;
    releaseDate!: Date;
    features!: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : <any>undefined;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)![key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = (<any>this.features)[key];
            }
        }
        return data;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: Date;
    features: { [key: string]: boolean; } | undefined;
}

export class AuthenticationToken implements IAuthenticationToken {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: IAuthenticationToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): AuthenticationToken {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IAuthenticationToken {
    name: string | undefined;
    value: string | undefined;
}

export class Calendar implements ICalendar {
    readonly minSupportedDateTime!: Date;
    readonly maxSupportedDateTime!: Date;
    algorithmType!: CalendarAlgorithmType;
    readonly isReadOnly!: boolean;
    readonly eras!: number[] | undefined;
    twoDigitYearMax!: number;

    constructor(data?: ICalendar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).minSupportedDateTime = _data["minSupportedDateTime"] ? new Date(_data["minSupportedDateTime"].toString()) : <any>undefined;
            (<any>this).maxSupportedDateTime = _data["maxSupportedDateTime"] ? new Date(_data["maxSupportedDateTime"].toString()) : <any>undefined;
            this.algorithmType = _data["algorithmType"];
            (<any>this).isReadOnly = _data["isReadOnly"];
            if (Array.isArray(_data["eras"])) {
                (<any>this).eras = [] as any;
                for (let item of _data["eras"])
                    (<any>this).eras!.push(item);
            }
            this.twoDigitYearMax = _data["twoDigitYearMax"];
        }
    }

    static fromJS(data: any): Calendar {
        data = typeof data === 'object' ? data : {};
        let result = new Calendar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minSupportedDateTime"] = this.minSupportedDateTime ? this.minSupportedDateTime.toISOString() : <any>undefined;
        data["maxSupportedDateTime"] = this.maxSupportedDateTime ? this.maxSupportedDateTime.toISOString() : <any>undefined;
        data["algorithmType"] = this.algorithmType;
        data["isReadOnly"] = this.isReadOnly;
        if (Array.isArray(this.eras)) {
            data["eras"] = [];
            for (let item of this.eras)
                data["eras"].push(item);
        }
        data["twoDigitYearMax"] = this.twoDigitYearMax;
        return data;
    }
}

export interface ICalendar {
    minSupportedDateTime: Date;
    maxSupportedDateTime: Date;
    algorithmType: CalendarAlgorithmType;
    isReadOnly: boolean;
    eras: number[] | undefined;
    twoDigitYearMax: number;
}

export enum CalendarAlgorithmType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class CalendarAvailability implements ICalendarAvailability {
    individual!: { [key: string]: TimeRange[]; } | undefined;
    weeklyRepeating!: { [key: string]: TimeRange[]; } | undefined;

    constructor(data?: ICalendarAvailability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["individual"]) {
                this.individual = {} as any;
                for (let key in _data["individual"]) {
                    if (_data["individual"].hasOwnProperty(key))
                        (<any>this.individual)![key] = _data["individual"][key] ? _data["individual"][key].map((i: any) => TimeRange.fromJS(i)) : <any>undefined;
                }
            }
            if (_data["weeklyRepeating"]) {
                this.weeklyRepeating = {} as any;
                for (let key in _data["weeklyRepeating"]) {
                    if (_data["weeklyRepeating"].hasOwnProperty(key))
                        (<any>this.weeklyRepeating)![key] = _data["weeklyRepeating"][key] ? _data["weeklyRepeating"][key].map((i: any) => TimeRange.fromJS(i)) : <any>undefined;
                }
            }
        }
    }

    static fromJS(data: any): CalendarAvailability {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarAvailability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.individual) {
            data["individual"] = {};
            for (let key in this.individual) {
                if (this.individual.hasOwnProperty(key))
                    (<any>data["individual"])[key] = (<any>this.individual)[key];
            }
        }
        if (this.weeklyRepeating) {
            data["weeklyRepeating"] = {};
            for (let key in this.weeklyRepeating) {
                if (this.weeklyRepeating.hasOwnProperty(key))
                    (<any>data["weeklyRepeating"])[key] = (<any>this.weeklyRepeating)[key];
            }
        }
        return data;
    }
}

export interface ICalendarAvailability {
    individual: { [key: string]: TimeRange[]; } | undefined;
    weeklyRepeating: { [key: string]: TimeRange[]; } | undefined;
}

export enum CalendarWeekRule {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName!: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class CompareInfo implements ICompareInfo {
    readonly name!: string | undefined;
    version!: SortVersion;
    readonly lcid!: number;

    constructor(data?: ICompareInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.version = data.version && !(<any>data.version).toJSON ? new SortVersion(data.version) : <SortVersion>this.version;
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.version = _data["version"] ? SortVersion.fromJS(_data["version"]) : <any>undefined;
            (<any>this).lcid = _data["lcid"];
        }
    }

    static fromJS(data: any): CompareInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CompareInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["version"] = this.version ? this.version.toJSON() : <any>undefined;
        data["lcid"] = this.lcid;
        return data;
    }
}

export interface ICompareInfo {
    name: string | undefined;
    version: ISortVersion;
    lcid: number;
}

export class CultureInfo implements ICultureInfo {
    parent!: CultureInfo;
    readonly lcid!: number;
    readonly keyboardLayoutId!: number;
    name!: string | undefined;
    readonly ietfLanguageTag!: string | undefined;
    readonly displayName!: string | undefined;
    readonly nativeName!: string | undefined;
    readonly englishName!: string | undefined;
    readonly twoLetterISOLanguageName!: string | undefined;
    readonly threeLetterISOLanguageName!: string | undefined;
    readonly threeLetterWindowsLanguageName!: string | undefined;
    compareInfo!: CompareInfo;
    textInfo!: TextInfo;
    readonly isNeutralCulture!: boolean;
    cultureTypes!: CultureTypes;
    numberFormat!: NumberFormatInfo;
    dateTimeFormat!: DateTimeFormatInfo;
    calendar!: Calendar;
    readonly optionalCalendars!: Calendar[] | undefined;
    readonly useUserOverride!: boolean;
    readonly isReadOnly!: boolean;

    constructor(data?: ICultureInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.parent = data.parent && !(<any>data.parent).toJSON ? new CultureInfo(data.parent) : <CultureInfo>this.parent;
            this.compareInfo = data.compareInfo && !(<any>data.compareInfo).toJSON ? new CompareInfo(data.compareInfo) : <CompareInfo>this.compareInfo;
            this.textInfo = data.textInfo && !(<any>data.textInfo).toJSON ? new TextInfo(data.textInfo) : <TextInfo>this.textInfo;
            this.numberFormat = data.numberFormat && !(<any>data.numberFormat).toJSON ? new NumberFormatInfo(data.numberFormat) : <NumberFormatInfo>this.numberFormat;
            this.dateTimeFormat = data.dateTimeFormat && !(<any>data.dateTimeFormat).toJSON ? new DateTimeFormatInfo(data.dateTimeFormat) : <DateTimeFormatInfo>this.dateTimeFormat;
            this.calendar = data.calendar && !(<any>data.calendar).toJSON ? new Calendar(data.calendar) : <Calendar>this.calendar;
            if (data.optionalCalendars) {
                this.optionalCalendars = [];
                for (let i = 0; i < data.optionalCalendars.length; i++) {
                    let item = data.optionalCalendars[i];
                    this.optionalCalendars[i] = item && !(<any>item).toJSON ? new Calendar(item) : <Calendar>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parent = _data["parent"] ? CultureInfo.fromJS(_data["parent"]) : <any>undefined;
            (<any>this).lcid = _data["lcid"];
            (<any>this).keyboardLayoutId = _data["keyboardLayoutId"];
            this.name = _data["name"];
            (<any>this).ietfLanguageTag = _data["ietfLanguageTag"];
            (<any>this).displayName = _data["displayName"];
            (<any>this).nativeName = _data["nativeName"];
            (<any>this).englishName = _data["englishName"];
            (<any>this).twoLetterISOLanguageName = _data["twoLetterISOLanguageName"];
            (<any>this).threeLetterISOLanguageName = _data["threeLetterISOLanguageName"];
            (<any>this).threeLetterWindowsLanguageName = _data["threeLetterWindowsLanguageName"];
            this.compareInfo = _data["compareInfo"] ? CompareInfo.fromJS(_data["compareInfo"]) : <any>undefined;
            this.textInfo = _data["textInfo"] ? TextInfo.fromJS(_data["textInfo"]) : <any>undefined;
            (<any>this).isNeutralCulture = _data["isNeutralCulture"];
            this.cultureTypes = _data["cultureTypes"];
            this.numberFormat = _data["numberFormat"] ? NumberFormatInfo.fromJS(_data["numberFormat"]) : <any>undefined;
            this.dateTimeFormat = _data["dateTimeFormat"] ? DateTimeFormatInfo.fromJS(_data["dateTimeFormat"]) : <any>undefined;
            this.calendar = _data["calendar"] ? Calendar.fromJS(_data["calendar"]) : <any>undefined;
            if (Array.isArray(_data["optionalCalendars"])) {
                (<any>this).optionalCalendars = [] as any;
                for (let item of _data["optionalCalendars"])
                    (<any>this).optionalCalendars!.push(Calendar.fromJS(item));
            }
            (<any>this).useUserOverride = _data["useUserOverride"];
            (<any>this).isReadOnly = _data["isReadOnly"];
        }
    }

    static fromJS(data: any): CultureInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CultureInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["lcid"] = this.lcid;
        data["keyboardLayoutId"] = this.keyboardLayoutId;
        data["name"] = this.name;
        data["ietfLanguageTag"] = this.ietfLanguageTag;
        data["displayName"] = this.displayName;
        data["nativeName"] = this.nativeName;
        data["englishName"] = this.englishName;
        data["twoLetterISOLanguageName"] = this.twoLetterISOLanguageName;
        data["threeLetterISOLanguageName"] = this.threeLetterISOLanguageName;
        data["threeLetterWindowsLanguageName"] = this.threeLetterWindowsLanguageName;
        data["compareInfo"] = this.compareInfo ? this.compareInfo.toJSON() : <any>undefined;
        data["textInfo"] = this.textInfo ? this.textInfo.toJSON() : <any>undefined;
        data["isNeutralCulture"] = this.isNeutralCulture;
        data["cultureTypes"] = this.cultureTypes;
        data["numberFormat"] = this.numberFormat ? this.numberFormat.toJSON() : <any>undefined;
        data["dateTimeFormat"] = this.dateTimeFormat ? this.dateTimeFormat.toJSON() : <any>undefined;
        data["calendar"] = this.calendar ? this.calendar.toJSON() : <any>undefined;
        if (Array.isArray(this.optionalCalendars)) {
            data["optionalCalendars"] = [];
            for (let item of this.optionalCalendars)
                data["optionalCalendars"].push(item.toJSON());
        }
        data["useUserOverride"] = this.useUserOverride;
        data["isReadOnly"] = this.isReadOnly;
        return data;
    }
}

export interface ICultureInfo {
    parent: ICultureInfo;
    lcid: number;
    keyboardLayoutId: number;
    name: string | undefined;
    ietfLanguageTag: string | undefined;
    displayName: string | undefined;
    nativeName: string | undefined;
    englishName: string | undefined;
    twoLetterISOLanguageName: string | undefined;
    threeLetterISOLanguageName: string | undefined;
    threeLetterWindowsLanguageName: string | undefined;
    compareInfo: ICompareInfo;
    textInfo: ITextInfo;
    isNeutralCulture: boolean;
    cultureTypes: CultureTypes;
    numberFormat: INumberFormatInfo;
    dateTimeFormat: IDateTimeFormatInfo;
    calendar: ICalendar;
    optionalCalendars: ICalendar[] | undefined;
    useUserOverride: boolean;
    isReadOnly: boolean;
}

export enum CultureTypes {
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _7 = 7,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
}

export class DateTimeFormatInfo implements IDateTimeFormatInfo {
    amDesignator!: string | undefined;
    calendar!: Calendar;
    dateSeparator!: string | undefined;
    firstDayOfWeek!: DayOfWeek;
    calendarWeekRule!: CalendarWeekRule;
    fullDateTimePattern!: string | undefined;
    longDatePattern!: string | undefined;
    longTimePattern!: string | undefined;
    monthDayPattern!: string | undefined;
    pmDesignator!: string | undefined;
    readonly rfC1123Pattern!: string | undefined;
    shortDatePattern!: string | undefined;
    shortTimePattern!: string | undefined;
    readonly sortableDateTimePattern!: string | undefined;
    timeSeparator!: string | undefined;
    readonly universalSortableDateTimePattern!: string | undefined;
    yearMonthPattern!: string | undefined;
    abbreviatedDayNames!: string[] | undefined;
    shortestDayNames!: string[] | undefined;
    dayNames!: string[] | undefined;
    abbreviatedMonthNames!: string[] | undefined;
    monthNames!: string[] | undefined;
    readonly isReadOnly!: boolean;
    readonly nativeCalendarName!: string | undefined;
    abbreviatedMonthGenitiveNames!: string[] | undefined;
    monthGenitiveNames!: string[] | undefined;

    constructor(data?: IDateTimeFormatInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.calendar = data.calendar && !(<any>data.calendar).toJSON ? new Calendar(data.calendar) : <Calendar>this.calendar;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amDesignator = _data["amDesignator"];
            this.calendar = _data["calendar"] ? Calendar.fromJS(_data["calendar"]) : <any>undefined;
            this.dateSeparator = _data["dateSeparator"];
            this.firstDayOfWeek = _data["firstDayOfWeek"];
            this.calendarWeekRule = _data["calendarWeekRule"];
            this.fullDateTimePattern = _data["fullDateTimePattern"];
            this.longDatePattern = _data["longDatePattern"];
            this.longTimePattern = _data["longTimePattern"];
            this.monthDayPattern = _data["monthDayPattern"];
            this.pmDesignator = _data["pmDesignator"];
            (<any>this).rfC1123Pattern = _data["rfC1123Pattern"];
            this.shortDatePattern = _data["shortDatePattern"];
            this.shortTimePattern = _data["shortTimePattern"];
            (<any>this).sortableDateTimePattern = _data["sortableDateTimePattern"];
            this.timeSeparator = _data["timeSeparator"];
            (<any>this).universalSortableDateTimePattern = _data["universalSortableDateTimePattern"];
            this.yearMonthPattern = _data["yearMonthPattern"];
            if (Array.isArray(_data["abbreviatedDayNames"])) {
                this.abbreviatedDayNames = [] as any;
                for (let item of _data["abbreviatedDayNames"])
                    this.abbreviatedDayNames!.push(item);
            }
            if (Array.isArray(_data["shortestDayNames"])) {
                this.shortestDayNames = [] as any;
                for (let item of _data["shortestDayNames"])
                    this.shortestDayNames!.push(item);
            }
            if (Array.isArray(_data["dayNames"])) {
                this.dayNames = [] as any;
                for (let item of _data["dayNames"])
                    this.dayNames!.push(item);
            }
            if (Array.isArray(_data["abbreviatedMonthNames"])) {
                this.abbreviatedMonthNames = [] as any;
                for (let item of _data["abbreviatedMonthNames"])
                    this.abbreviatedMonthNames!.push(item);
            }
            if (Array.isArray(_data["monthNames"])) {
                this.monthNames = [] as any;
                for (let item of _data["monthNames"])
                    this.monthNames!.push(item);
            }
            (<any>this).isReadOnly = _data["isReadOnly"];
            (<any>this).nativeCalendarName = _data["nativeCalendarName"];
            if (Array.isArray(_data["abbreviatedMonthGenitiveNames"])) {
                this.abbreviatedMonthGenitiveNames = [] as any;
                for (let item of _data["abbreviatedMonthGenitiveNames"])
                    this.abbreviatedMonthGenitiveNames!.push(item);
            }
            if (Array.isArray(_data["monthGenitiveNames"])) {
                this.monthGenitiveNames = [] as any;
                for (let item of _data["monthGenitiveNames"])
                    this.monthGenitiveNames!.push(item);
            }
        }
    }

    static fromJS(data: any): DateTimeFormatInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeFormatInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amDesignator"] = this.amDesignator;
        data["calendar"] = this.calendar ? this.calendar.toJSON() : <any>undefined;
        data["dateSeparator"] = this.dateSeparator;
        data["firstDayOfWeek"] = this.firstDayOfWeek;
        data["calendarWeekRule"] = this.calendarWeekRule;
        data["fullDateTimePattern"] = this.fullDateTimePattern;
        data["longDatePattern"] = this.longDatePattern;
        data["longTimePattern"] = this.longTimePattern;
        data["monthDayPattern"] = this.monthDayPattern;
        data["pmDesignator"] = this.pmDesignator;
        data["rfC1123Pattern"] = this.rfC1123Pattern;
        data["shortDatePattern"] = this.shortDatePattern;
        data["shortTimePattern"] = this.shortTimePattern;
        data["sortableDateTimePattern"] = this.sortableDateTimePattern;
        data["timeSeparator"] = this.timeSeparator;
        data["universalSortableDateTimePattern"] = this.universalSortableDateTimePattern;
        data["yearMonthPattern"] = this.yearMonthPattern;
        if (Array.isArray(this.abbreviatedDayNames)) {
            data["abbreviatedDayNames"] = [];
            for (let item of this.abbreviatedDayNames)
                data["abbreviatedDayNames"].push(item);
        }
        if (Array.isArray(this.shortestDayNames)) {
            data["shortestDayNames"] = [];
            for (let item of this.shortestDayNames)
                data["shortestDayNames"].push(item);
        }
        if (Array.isArray(this.dayNames)) {
            data["dayNames"] = [];
            for (let item of this.dayNames)
                data["dayNames"].push(item);
        }
        if (Array.isArray(this.abbreviatedMonthNames)) {
            data["abbreviatedMonthNames"] = [];
            for (let item of this.abbreviatedMonthNames)
                data["abbreviatedMonthNames"].push(item);
        }
        if (Array.isArray(this.monthNames)) {
            data["monthNames"] = [];
            for (let item of this.monthNames)
                data["monthNames"].push(item);
        }
        data["isReadOnly"] = this.isReadOnly;
        data["nativeCalendarName"] = this.nativeCalendarName;
        if (Array.isArray(this.abbreviatedMonthGenitiveNames)) {
            data["abbreviatedMonthGenitiveNames"] = [];
            for (let item of this.abbreviatedMonthGenitiveNames)
                data["abbreviatedMonthGenitiveNames"].push(item);
        }
        if (Array.isArray(this.monthGenitiveNames)) {
            data["monthGenitiveNames"] = [];
            for (let item of this.monthGenitiveNames)
                data["monthGenitiveNames"].push(item);
        }
        return data;
    }
}

export interface IDateTimeFormatInfo {
    amDesignator: string | undefined;
    calendar: ICalendar;
    dateSeparator: string | undefined;
    firstDayOfWeek: DayOfWeek;
    calendarWeekRule: CalendarWeekRule;
    fullDateTimePattern: string | undefined;
    longDatePattern: string | undefined;
    longTimePattern: string | undefined;
    monthDayPattern: string | undefined;
    pmDesignator: string | undefined;
    rfC1123Pattern: string | undefined;
    shortDatePattern: string | undefined;
    shortTimePattern: string | undefined;
    sortableDateTimePattern: string | undefined;
    timeSeparator: string | undefined;
    universalSortableDateTimePattern: string | undefined;
    yearMonthPattern: string | undefined;
    abbreviatedDayNames: string[] | undefined;
    shortestDayNames: string[] | undefined;
    dayNames: string[] | undefined;
    abbreviatedMonthNames: string[] | undefined;
    monthNames: string[] | undefined;
    isReadOnly: boolean;
    nativeCalendarName: string | undefined;
    abbreviatedMonthGenitiveNames: string[] | undefined;
    monthGenitiveNames: string[] | undefined;
}

export enum DayOfWeek {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export enum DigitShapes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class ExternalCalendarDto implements IExternalCalendarDto {
    id!: string;
    externalProviderName!: string | undefined;
    externalUserId!: string | undefined;
    externalCalendarId!: string | undefined;
    userId!: number;
    name!: string | undefined;
    isBlocking!: boolean;
    isOutputting!: boolean;
    isReadonly!: boolean;

    constructor(data?: IExternalCalendarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalProviderName = _data["externalProviderName"];
            this.externalUserId = _data["externalUserId"];
            this.externalCalendarId = _data["externalCalendarId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.isBlocking = _data["isBlocking"];
            this.isOutputting = _data["isOutputting"];
            this.isReadonly = _data["isReadonly"];
        }
    }

    static fromJS(data: any): ExternalCalendarDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalCalendarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalProviderName"] = this.externalProviderName;
        data["externalUserId"] = this.externalUserId;
        data["externalCalendarId"] = this.externalCalendarId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["isBlocking"] = this.isBlocking;
        data["isOutputting"] = this.isOutputting;
        data["isReadonly"] = this.isReadonly;
        return data;
    }
}

export interface IExternalCalendarDto {
    id: string;
    externalProviderName: string | undefined;
    externalUserId: string | undefined;
    externalCalendarId: string | undefined;
    userId: number;
    name: string | undefined;
    isBlocking: boolean;
    isOutputting: boolean;
    isReadonly: boolean;
}

export class ExternalCalendarProviderWithCalendars implements IExternalCalendarProviderWithCalendars {
    externalProviderName!: string | undefined;
    externalUserId!: string | undefined;
    calendars!: ExternalCalendarDto[] | undefined;
    accountEmail!: string | undefined;
    isActive!: boolean;

    constructor(data?: IExternalCalendarProviderWithCalendars) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.calendars) {
                this.calendars = [];
                for (let i = 0; i < data.calendars.length; i++) {
                    let item = data.calendars[i];
                    this.calendars[i] = item && !(<any>item).toJSON ? new ExternalCalendarDto(item) : <ExternalCalendarDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalProviderName = _data["externalProviderName"];
            this.externalUserId = _data["externalUserId"];
            if (Array.isArray(_data["calendars"])) {
                this.calendars = [] as any;
                for (let item of _data["calendars"])
                    this.calendars!.push(ExternalCalendarDto.fromJS(item));
            }
            this.accountEmail = _data["accountEmail"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ExternalCalendarProviderWithCalendars {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalCalendarProviderWithCalendars();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalProviderName"] = this.externalProviderName;
        data["externalUserId"] = this.externalUserId;
        if (Array.isArray(this.calendars)) {
            data["calendars"] = [];
            for (let item of this.calendars)
                data["calendars"].push(item.toJSON());
        }
        data["accountEmail"] = this.accountEmail;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IExternalCalendarProviderWithCalendars {
    externalProviderName: string | undefined;
    externalUserId: string | undefined;
    calendars: IExternalCalendarDto[] | undefined;
    accountEmail: string | undefined;
    isActive: boolean;
}

export class GetConnectedAccountsAsyncOutput implements IGetConnectedAccountsAsyncOutput {
    loginProvider!: string | undefined;
    providerKey!: string | undefined;
    providerDisplayName!: string | undefined;
    userDisplayName!: string | undefined;
    isActive!: boolean;

    constructor(data?: IGetConnectedAccountsAsyncOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loginProvider = _data["loginProvider"];
            this.providerKey = _data["providerKey"];
            this.providerDisplayName = _data["providerDisplayName"];
            this.userDisplayName = _data["userDisplayName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): GetConnectedAccountsAsyncOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetConnectedAccountsAsyncOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        data["providerDisplayName"] = this.providerDisplayName;
        data["userDisplayName"] = this.userDisplayName;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IGetConnectedAccountsAsyncOutput {
    loginProvider: string | undefined;
    providerKey: string | undefined;
    providerDisplayName: string | undefined;
    userDisplayName: string | undefined;
    isActive: boolean;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application!: ApplicationInfoDto;
    user!: UserLoginInfoDto;
    tenant!: TenantLoginInfoDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.application = data.application && !(<any>data.application).toJSON ? new ApplicationInfoDto(data.application) : <ApplicationInfoDto>this.application;
            this.user = data.user && !(<any>data.user).toJSON ? new UserLoginInfoDto(data.user) : <UserLoginInfoDto>this.user;
            this.tenant = data.tenant && !(<any>data.tenant).toJSON ? new TenantLoginInfoDto(data.tenant) : <TenantLoginInfoDto>this.tenant;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: IApplicationInfoDto;
    user: IUserLoginInfoDto;
    tenant: ITenantLoginInfoDto;
}

export class GetSelfOutput implements IGetSelfOutput {
    name!: string;
    surname!: string;
    username!: string | undefined;
    companyName!: string | undefined;
    timezone!: string | undefined;
    calendarAvailability!: CalendarAvailability;

    constructor(data?: IGetSelfOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.calendarAvailability = data.calendarAvailability && !(<any>data.calendarAvailability).toJSON ? new CalendarAvailability(data.calendarAvailability) : <CalendarAvailability>this.calendarAvailability;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.username = _data["username"];
            this.companyName = _data["companyName"];
            this.timezone = _data["timezone"];
            this.calendarAvailability = _data["calendarAvailability"] ? CalendarAvailability.fromJS(_data["calendarAvailability"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSelfOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSelfOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["username"] = this.username;
        data["companyName"] = this.companyName;
        data["timezone"] = this.timezone;
        data["calendarAvailability"] = this.calendarAvailability ? this.calendarAvailability.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSelfOutput {
    name: string;
    surname: string;
    username: string | undefined;
    companyName: string | undefined;
    timezone: string | undefined;
    calendarAvailability: ICalendarAvailability;
}

export class NumberFormatInfo implements INumberFormatInfo {
    currencyDecimalDigits!: number;
    currencyDecimalSeparator!: string | undefined;
    readonly isReadOnly!: boolean;
    currencyGroupSizes!: number[] | undefined;
    numberGroupSizes!: number[] | undefined;
    percentGroupSizes!: number[] | undefined;
    currencyGroupSeparator!: string | undefined;
    currencySymbol!: string | undefined;
    naNSymbol!: string | undefined;
    currencyNegativePattern!: number;
    numberNegativePattern!: number;
    percentPositivePattern!: number;
    percentNegativePattern!: number;
    negativeInfinitySymbol!: string | undefined;
    negativeSign!: string | undefined;
    numberDecimalDigits!: number;
    numberDecimalSeparator!: string | undefined;
    numberGroupSeparator!: string | undefined;
    currencyPositivePattern!: number;
    positiveInfinitySymbol!: string | undefined;
    positiveSign!: string | undefined;
    percentDecimalDigits!: number;
    percentDecimalSeparator!: string | undefined;
    percentGroupSeparator!: string | undefined;
    percentSymbol!: string | undefined;
    perMilleSymbol!: string | undefined;
    nativeDigits!: string[] | undefined;
    digitSubstitution!: DigitShapes;

    constructor(data?: INumberFormatInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyDecimalDigits = _data["currencyDecimalDigits"];
            this.currencyDecimalSeparator = _data["currencyDecimalSeparator"];
            (<any>this).isReadOnly = _data["isReadOnly"];
            if (Array.isArray(_data["currencyGroupSizes"])) {
                this.currencyGroupSizes = [] as any;
                for (let item of _data["currencyGroupSizes"])
                    this.currencyGroupSizes!.push(item);
            }
            if (Array.isArray(_data["numberGroupSizes"])) {
                this.numberGroupSizes = [] as any;
                for (let item of _data["numberGroupSizes"])
                    this.numberGroupSizes!.push(item);
            }
            if (Array.isArray(_data["percentGroupSizes"])) {
                this.percentGroupSizes = [] as any;
                for (let item of _data["percentGroupSizes"])
                    this.percentGroupSizes!.push(item);
            }
            this.currencyGroupSeparator = _data["currencyGroupSeparator"];
            this.currencySymbol = _data["currencySymbol"];
            this.naNSymbol = _data["naNSymbol"];
            this.currencyNegativePattern = _data["currencyNegativePattern"];
            this.numberNegativePattern = _data["numberNegativePattern"];
            this.percentPositivePattern = _data["percentPositivePattern"];
            this.percentNegativePattern = _data["percentNegativePattern"];
            this.negativeInfinitySymbol = _data["negativeInfinitySymbol"];
            this.negativeSign = _data["negativeSign"];
            this.numberDecimalDigits = _data["numberDecimalDigits"];
            this.numberDecimalSeparator = _data["numberDecimalSeparator"];
            this.numberGroupSeparator = _data["numberGroupSeparator"];
            this.currencyPositivePattern = _data["currencyPositivePattern"];
            this.positiveInfinitySymbol = _data["positiveInfinitySymbol"];
            this.positiveSign = _data["positiveSign"];
            this.percentDecimalDigits = _data["percentDecimalDigits"];
            this.percentDecimalSeparator = _data["percentDecimalSeparator"];
            this.percentGroupSeparator = _data["percentGroupSeparator"];
            this.percentSymbol = _data["percentSymbol"];
            this.perMilleSymbol = _data["perMilleSymbol"];
            if (Array.isArray(_data["nativeDigits"])) {
                this.nativeDigits = [] as any;
                for (let item of _data["nativeDigits"])
                    this.nativeDigits!.push(item);
            }
            this.digitSubstitution = _data["digitSubstitution"];
        }
    }

    static fromJS(data: any): NumberFormatInfo {
        data = typeof data === 'object' ? data : {};
        let result = new NumberFormatInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyDecimalDigits"] = this.currencyDecimalDigits;
        data["currencyDecimalSeparator"] = this.currencyDecimalSeparator;
        data["isReadOnly"] = this.isReadOnly;
        if (Array.isArray(this.currencyGroupSizes)) {
            data["currencyGroupSizes"] = [];
            for (let item of this.currencyGroupSizes)
                data["currencyGroupSizes"].push(item);
        }
        if (Array.isArray(this.numberGroupSizes)) {
            data["numberGroupSizes"] = [];
            for (let item of this.numberGroupSizes)
                data["numberGroupSizes"].push(item);
        }
        if (Array.isArray(this.percentGroupSizes)) {
            data["percentGroupSizes"] = [];
            for (let item of this.percentGroupSizes)
                data["percentGroupSizes"].push(item);
        }
        data["currencyGroupSeparator"] = this.currencyGroupSeparator;
        data["currencySymbol"] = this.currencySymbol;
        data["naNSymbol"] = this.naNSymbol;
        data["currencyNegativePattern"] = this.currencyNegativePattern;
        data["numberNegativePattern"] = this.numberNegativePattern;
        data["percentPositivePattern"] = this.percentPositivePattern;
        data["percentNegativePattern"] = this.percentNegativePattern;
        data["negativeInfinitySymbol"] = this.negativeInfinitySymbol;
        data["negativeSign"] = this.negativeSign;
        data["numberDecimalDigits"] = this.numberDecimalDigits;
        data["numberDecimalSeparator"] = this.numberDecimalSeparator;
        data["numberGroupSeparator"] = this.numberGroupSeparator;
        data["currencyPositivePattern"] = this.currencyPositivePattern;
        data["positiveInfinitySymbol"] = this.positiveInfinitySymbol;
        data["positiveSign"] = this.positiveSign;
        data["percentDecimalDigits"] = this.percentDecimalDigits;
        data["percentDecimalSeparator"] = this.percentDecimalSeparator;
        data["percentGroupSeparator"] = this.percentGroupSeparator;
        data["percentSymbol"] = this.percentSymbol;
        data["perMilleSymbol"] = this.perMilleSymbol;
        if (Array.isArray(this.nativeDigits)) {
            data["nativeDigits"] = [];
            for (let item of this.nativeDigits)
                data["nativeDigits"].push(item);
        }
        data["digitSubstitution"] = this.digitSubstitution;
        return data;
    }
}

export interface INumberFormatInfo {
    currencyDecimalDigits: number;
    currencyDecimalSeparator: string | undefined;
    isReadOnly: boolean;
    currencyGroupSizes: number[] | undefined;
    numberGroupSizes: number[] | undefined;
    percentGroupSizes: number[] | undefined;
    currencyGroupSeparator: string | undefined;
    currencySymbol: string | undefined;
    naNSymbol: string | undefined;
    currencyNegativePattern: number;
    numberNegativePattern: number;
    percentPositivePattern: number;
    percentNegativePattern: number;
    negativeInfinitySymbol: string | undefined;
    negativeSign: string | undefined;
    numberDecimalDigits: number;
    numberDecimalSeparator: string | undefined;
    numberGroupSeparator: string | undefined;
    currencyPositivePattern: number;
    positiveInfinitySymbol: string | undefined;
    positiveSign: string | undefined;
    percentDecimalDigits: number;
    percentDecimalSeparator: string | undefined;
    percentGroupSeparator: string | undefined;
    percentSymbol: string | undefined;
    perMilleSymbol: string | undefined;
    nativeDigits: string[] | undefined;
    digitSubstitution: DigitShapes;
}

export class PictureInput implements IPictureInput {
    image!: string | undefined;

    constructor(data?: IPictureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): PictureInput {
        data = typeof data === 'object' ? data : {};
        let result = new PictureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image;
        return data;
    }
}

export interface IPictureInput {
    image: string | undefined;
}

export class SaveBlockingOutputCalendarPreferencesInput implements ISaveBlockingOutputCalendarPreferencesInput {
    blockingCalendars!: string[] | undefined;
    outputCalendars!: string[] | undefined;

    constructor(data?: ISaveBlockingOutputCalendarPreferencesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["blockingCalendars"])) {
                this.blockingCalendars = [] as any;
                for (let item of _data["blockingCalendars"])
                    this.blockingCalendars!.push(item);
            }
            if (Array.isArray(_data["outputCalendars"])) {
                this.outputCalendars = [] as any;
                for (let item of _data["outputCalendars"])
                    this.outputCalendars!.push(item);
            }
        }
    }

    static fromJS(data: any): SaveBlockingOutputCalendarPreferencesInput {
        data = typeof data === 'object' ? data : {};
        let result = new SaveBlockingOutputCalendarPreferencesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.blockingCalendars)) {
            data["blockingCalendars"] = [];
            for (let item of this.blockingCalendars)
                data["blockingCalendars"].push(item);
        }
        if (Array.isArray(this.outputCalendars)) {
            data["outputCalendars"] = [];
            for (let item of this.outputCalendars)
                data["outputCalendars"].push(item);
        }
        return data;
    }
}

export interface ISaveBlockingOutputCalendarPreferencesInput {
    blockingCalendars: string[] | undefined;
    outputCalendars: string[] | undefined;
}

export class SortVersion implements ISortVersion {
    fullVersion!: number;
    sortId!: string;

    constructor(data?: ISortVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullVersion = _data["fullVersion"];
            this.sortId = _data["sortId"];
        }
    }

    static fromJS(data: any): SortVersion {
        data = typeof data === 'object' ? data : {};
        let result = new SortVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullVersion"] = this.fullVersion;
        data["sortId"] = this.sortId;
        return data;
    }
}

export interface ISortVersion {
    fullVersion: number;
    sortId: string;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    id!: number;
    tenancyName!: string | undefined;
    name!: string | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        return data;
    }
}

export interface ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
}

export class TextInfo implements ITextInfo {
    readonly ansiCodePage!: number;
    readonly oemCodePage!: number;
    readonly macCodePage!: number;
    readonly ebcdicCodePage!: number;
    readonly lcid!: number;
    readonly cultureName!: string | undefined;
    readonly isReadOnly!: boolean;
    listSeparator!: string | undefined;
    readonly isRightToLeft!: boolean;

    constructor(data?: ITextInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).ansiCodePage = _data["ansiCodePage"];
            (<any>this).oemCodePage = _data["oemCodePage"];
            (<any>this).macCodePage = _data["macCodePage"];
            (<any>this).ebcdicCodePage = _data["ebcdicCodePage"];
            (<any>this).lcid = _data["lcid"];
            (<any>this).cultureName = _data["cultureName"];
            (<any>this).isReadOnly = _data["isReadOnly"];
            this.listSeparator = _data["listSeparator"];
            (<any>this).isRightToLeft = _data["isRightToLeft"];
        }
    }

    static fromJS(data: any): TextInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TextInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ansiCodePage"] = this.ansiCodePage;
        data["oemCodePage"] = this.oemCodePage;
        data["macCodePage"] = this.macCodePage;
        data["ebcdicCodePage"] = this.ebcdicCodePage;
        data["lcid"] = this.lcid;
        data["cultureName"] = this.cultureName;
        data["isReadOnly"] = this.isReadOnly;
        data["listSeparator"] = this.listSeparator;
        data["isRightToLeft"] = this.isRightToLeft;
        return data;
    }
}

export interface ITextInfo {
    ansiCodePage: number;
    oemCodePage: number;
    macCodePage: number;
    ebcdicCodePage: number;
    lcid: number;
    cultureName: string | undefined;
    isReadOnly: boolean;
    listSeparator: string | undefined;
    isRightToLeft: boolean;
}

export class Time implements ITime {
    hours!: number;
    minutes!: number;

    constructor(data?: ITime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hours = _data["hours"];
            this.minutes = _data["minutes"];
        }
    }

    static fromJS(data: any): Time {
        data = typeof data === 'object' ? data : {};
        let result = new Time();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hours"] = this.hours;
        data["minutes"] = this.minutes;
        return data;
    }
}

export interface ITime {
    hours: number;
    minutes: number;
}

export class TimeRange implements ITimeRange {
    start!: Time;
    end!: Time;

    constructor(data?: ITimeRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.start = data.start && !(<any>data.start).toJSON ? new Time(data.start) : <Time>this.start;
            this.end = data.end && !(<any>data.end).toJSON ? new Time(data.end) : <Time>this.end;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? Time.fromJS(_data["start"]) : <any>undefined;
            this.end = _data["end"] ? Time.fromJS(_data["end"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TimeRange {
        data = typeof data === 'object' ? data : {};
        let result = new TimeRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toJSON() : <any>undefined;
        data["end"] = this.end ? this.end.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITimeRange {
    start: ITime;
    end: ITime;
}

export class UpdateExternalCalendarBlockSaveDto implements IUpdateExternalCalendarBlockSaveDto {
    id!: string;
    set!: boolean;

    constructor(data?: IUpdateExternalCalendarBlockSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.set = _data["set"];
        }
    }

    static fromJS(data: any): UpdateExternalCalendarBlockSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExternalCalendarBlockSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["set"] = this.set;
        return data;
    }
}

export interface IUpdateExternalCalendarBlockSaveDto {
    id: string;
    set: boolean;
}

export class UpdateSelfInput implements IUpdateSelfInput {
    name!: string;
    surname!: string | undefined;
    username!: string;
    companyName!: string | undefined;
    timeZone!: string | undefined;

    constructor(data?: IUpdateSelfInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.username = _data["username"];
            this.companyName = _data["companyName"];
            this.timeZone = _data["timeZone"];
        }
    }

    static fromJS(data: any): UpdateSelfInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSelfInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["username"] = this.username;
        data["companyName"] = this.companyName;
        data["timeZone"] = this.timeZone;
        return data;
    }
}

export interface IUpdateSelfInput {
    name: string;
    surname: string | undefined;
    username: string;
    companyName: string | undefined;
    timeZone: string | undefined;
}

export class UserDto implements IUserDto {
    id!: number;
    bookingPages!: number;
    userName!: string;
    name!: string;
    surname!: string;
    companyName!: string | undefined;
    emailAddress!: string;
    isActive!: boolean;
    isDeleted!: boolean;
    fullName!: string | undefined;
    lastLoginTime!: Date | undefined;
    creationTime!: Date;
    roleNames!: string[] | undefined;
    isEmailConfirmed!: boolean;
    profilePic!: string | undefined;
    remainingMeetings!: number;
    timezone!: string | undefined;
    meetingsBooked!: number;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bookingPages = _data["bookingPages"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.companyName = _data["companyName"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.fullName = _data["fullName"];
            this.lastLoginTime = _data["lastLoginTime"] ? new Date(_data["lastLoginTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.profilePic = _data["profilePic"];
            this.remainingMeetings = _data["remainingMeetings"];
            this.timezone = _data["timezone"];
            this.meetingsBooked = _data["meetingsBooked"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bookingPages"] = this.bookingPages;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["companyName"] = this.companyName;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["fullName"] = this.fullName;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["profilePic"] = this.profilePic;
        data["remainingMeetings"] = this.remainingMeetings;
        data["timezone"] = this.timezone;
        data["meetingsBooked"] = this.meetingsBooked;
        return data;
    }
}

export interface IUserDto {
    id: number;
    bookingPages: number;
    userName: string;
    name: string;
    surname: string;
    companyName: string | undefined;
    emailAddress: string;
    isActive: boolean;
    isDeleted: boolean;
    fullName: string | undefined;
    lastLoginTime: Date | undefined;
    creationTime: Date;
    roleNames: string[] | undefined;
    isEmailConfirmed: boolean;
    profilePic: string | undefined;
    remainingMeetings: number;
    timezone: string | undefined;
    meetingsBooked: number;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    timezone!: string | undefined;
    companyName!: string | undefined;
    profilePic!: string | undefined;
    remainingMeetings!: number;
    calendarAvailability!: CalendarAvailability;
    totalLicenses!: number;
    hasStripeSubscription!: boolean;
    stripeId!: string | undefined;
    hasCompletedOnboarding!: boolean;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.calendarAvailability = data.calendarAvailability && !(<any>data.calendarAvailability).toJSON ? new CalendarAvailability(data.calendarAvailability) : <CalendarAvailability>this.calendarAvailability;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.timezone = _data["timezone"];
            this.companyName = _data["companyName"];
            this.profilePic = _data["profilePic"];
            this.remainingMeetings = _data["remainingMeetings"];
            this.calendarAvailability = _data["calendarAvailability"] ? CalendarAvailability.fromJS(_data["calendarAvailability"]) : <any>undefined;
            this.totalLicenses = _data["totalLicenses"];
            this.hasStripeSubscription = _data["hasStripeSubscription"];
            this.stripeId = _data["stripeId"];
            this.hasCompletedOnboarding = _data["hasCompletedOnboarding"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["timezone"] = this.timezone;
        data["companyName"] = this.companyName;
        data["profilePic"] = this.profilePic;
        data["remainingMeetings"] = this.remainingMeetings;
        data["calendarAvailability"] = this.calendarAvailability ? this.calendarAvailability.toJSON() : <any>undefined;
        data["totalLicenses"] = this.totalLicenses;
        data["hasStripeSubscription"] = this.hasStripeSubscription;
        data["stripeId"] = this.stripeId;
        data["hasCompletedOnboarding"] = this.hasCompletedOnboarding;
        return data;
    }
}

export interface IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    timezone: string | undefined;
    companyName: string | undefined;
    profilePic: string | undefined;
    remainingMeetings: number;
    calendarAvailability: ICalendarAvailability;
    totalLicenses: number;
    hasStripeSubscription: boolean;
    stripeId: string | undefined;
    hasCompletedOnboarding: boolean;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}